import { Card, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { InfoCircleFill } from "react-bootstrap-icons";
import { Button } from "./Controls/Button";
import { ReservationVehicleCard } from "./UserPlanDetailsPage";
import { SubscriptionParker, Vehicle } from "./Data/ApiTypes";
import { SubscriptionStatus } from "./Data/ApiTransport";
import { GROUP_PARKER_VEHICLE_LIMIT } from "./Data/VehicleLimit";

interface Props {
    show: boolean;
    onClose: () => void;
    parker: SubscriptionParker;
    subStatus: SubscriptionStatus;
    onAddNew?: () => void;
    onAddExisting?: () => void;
    onRemoveVehicle?: (vehicle: Vehicle) => void;
}

/** Vehicles-only modal (no parker settings / QR). */
export function ParkerVehiclesModal({
    show,
    onClose,
    parker,
    subStatus,
    onAddNew,
    onAddExisting,
    onRemoveVehicle,
}: Props) {
    const vehicleCount = parker.vehicles?.length ?? 0;
    const atVehicleLimit = vehicleCount >= GROUP_PARKER_VEHICLE_LIMIT;
    const canEdit = subStatus === SubscriptionStatus.Active && !atVehicleLimit;

    return (
        <Modal show={show} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Manage Vehicles — {parker.parker.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card>
                    <Card.Header
                        style={{
                            display: "grid",
                            gridTemplateColumns: "max-content 1fr max-content max-content",
                        }}
                    >
                        <div>Vehicles</div>
                        <div />
                        <div>
                            {canEdit && (
                                <>
                                    <Link
                                        to=""
                                        onClick={(e) => {
                                            e.preventDefault();
                                            onAddNew?.();
                                        }}
                                    >
                                        Add New
                                    </Link>
                                    <>
                                        &nbsp;|&nbsp;
                                        <Link
                                            to=""
                                            onClick={(e) => {
                                                e.preventDefault();
                                                onAddExisting?.();
                                            }}
                                        >
                                            Add Existing
                                        </Link>
                                    </>
                                </>
                            )}
                        </div>
                    </Card.Header>
                    <Card.Body>
                        {atVehicleLimit && (
                            <div className="alert alert-muted-gold d-flex align-items-start gap-2 mb-2 small" role="alert">
                                <InfoCircleFill className="flex-shrink-0 mt-1" />
                                <span>No more vehicles can be added to the subscription.</span>
                            </div>
                        )}
                        {!parker.vehicles?.length ? (
                            <div className="d-flex flex-column align-items-center justify-content-center text-center py-3">
                                <div
                                    className="rounded-circle mb-3"
                                    style={{
                                        width: 72,
                                        height: 72,
                                        backgroundColor: "rgba(220, 53, 69, 0.15)",
                                    }}
                                />
                                <p className="text-secondary mb-4 mx-auto" style={{ maxWidth: 360 }}>
                                    Add vehicles to authorize them to access the lot as part of this subscription.
                                </p>
                                {canEdit && (
                                    <Button className="btn-main px-4" onClick={() => onAddNew?.()}>
                                        Add Vehicle
                                    </Button>
                                )}
                            </div>
                        ) : (
                            parker.vehicles.map((v) => (
                                <ReservationVehicleCard
                                    key={v.vehicleId}
                                    vehicle={v}
                                    subscriptionStatus={subStatus}
                                    onRemove={() => onRemoveVehicle?.(v)}
                                />
                            ))
                        )}
                    </Card.Body>
                </Card>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" className="w-100" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
